import { createTheme } from '@mui/material/styles';

const colors = {
  valeoGreen: '#82e600',
  valeoNavy: '#4e6b7c',
};

const theme = createTheme({
  palette: {
    primary: {
      main: colors.valeoGreen,
    },
    secondary: {
      main: colors.valeoNavy,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: '600',
          fontSize: '14px',
        },
      },
    },
  },
});

export default theme;
